import abi from './abi.json'
const address = "0x5864c777697Bf9881220328BF2f16908c9aFCD7e"
const busd = {abi,address}
export default busd